import { render, staticRenderFns } from "./modal-gift-card.vue?vue&type=template&id=0a3107ae&"
import script from "./modal-gift-card.vue?vue&type=script&lang=js&"
export * from "./modal-gift-card.vue?vue&type=script&lang=js&"
import style0 from "./modal-gift-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports